import React from 'react';
import {Table, Button, Input} from 'antd';
import Info from '../Detail/Info';

class Timeline extends React.Component {
    constructor(props) {
        super();
    }

    columns = [
        {
            title:"时间",
            dataIndex:"time",
            render:(time, record)=>{
                return <div>
                    <Info useLabel={false} placeholder="开始时间" type="datetime" value={time} onChange={this.setKeyValue.bind(this, record, 'time')} />
                    <Info useLabel={false} placeholder="结束时间" type="datetime" value={record.endtime} onChange={this.setKeyValue.bind(this, record, 'endtime')} />
                </div>;
            }
        },
        {
            title:"描述",
            dataIndex:"intro",
            render:(intro, record)=>{
                return <Info type="textarea" value={intro} useLabel={false} onChange={this.setKeyValue.bind(this, record, 'intro')} />;
            }
        },
        {
            title:"操作",
            render:(field, record, index)=>{
                return <a  onClick={()=>this.deleteHandler(index)}>删除</a>;
            }
        }
    ];

    setKeyValue(record, key, val) {
        let {onChange, value} = this.props;

        var target = value.find(it=>it.index == record.index);
        if(key == 'time' || key == 'endtime') {
            val = Math.floor(val.toDate().getTime()/1000)*1000;
        }
        target[key] = val;

        onChange(value);
    }

    deleteHandler = (index)=>{
        let {onChange, value} = this.props;

        value = value instanceof Array ? value : [];
        if(value[index]) {
            value.splice(index, 1);
        }

        onChange(value);
    }

    addOne = ()=>{
        let {onChange, value} = this.props;

        value = value instanceof Array ? value : [];
        value.push({
            index:value.length+1,
            time:"",
            intro:""
        });

        onChange(value);
    }

    render() {
        let {value} = this.props;
        value = value instanceof Array ? value : [];
        return <div className="guestlist">
            <Table columns={this.columns}
                dataSource={value}
                rowKey={"index"}
                footer={()=>(<a  onClick={this.addOne}>添加一行</a>)}
            />
        </div>;
    }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/Select/Timeline.js